import { render, staticRenderFns } from "./LeftNavBar.vue?vue&type=template&id=0a4615a2&scoped=true"
import script from "./LeftNavBar.vue?vue&type=script&lang=js"
export * from "./LeftNavBar.vue?vue&type=script&lang=js"
import style0 from "./LeftNavBar.vue?vue&type=style&index=0&id=0a4615a2&prod&lang=css"
import style1 from "./LeftNavBar.vue?vue&type=style&index=1&id=0a4615a2&prod&lang=scss"
import style2 from "./LeftNavBar.vue?vue&type=style&index=2&id=0a4615a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../touch/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4615a2",
  null
  
)

export default component.exports